import { defineComponent, onMounted, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { usePaymentMethodsExceptionLimitStore } from '@/store/ps-management/geo-payment-method-exception-limits.store';
import { usePermissionsStore } from '@/store/permissions.store';
import { PS_MANAGEMENT_PERMISSIONS } from '@/models/app-internal/permissions.model';
import { DEFAULT_EXCEPTION_LIMIT, PaymentMethodExceptionLimit } from '@/models/ps-management/exception-limit.model';
import LimitException from '@/layouts/ps-management-page/limit-ecxeption-settings/limit-ecxeption/limit-ecxeption.vue';

export default defineComponent({
  name: 'LimitExceptionSettings',
  components: {
    LimitException,
  },
  setup() {
    const paymentMethodsExceptionLimitStore = usePaymentMethodsExceptionLimitStore();
    const {
      isExceptionLimitSettingsSidebarVisible,
      extendedPaymentMethodExceptionLimitList,
      exceptionLimitList,
      isExceptionLimitListLoading,
      currentGeoPaymentMethodId,
      currentGeoPaymentMethod,
    } = storeToRefs(paymentMethodsExceptionLimitStore);
    const {
      closeExceptionLimitSettings,
      getGeoPaymentMethodExceptionLimit,
      getGeoPaymentMethodGeneralLimit,
    } = paymentMethodsExceptionLimitStore;

    const { psManagementPermissions } = storeToRefs(usePermissionsStore());

    onMounted(() => {
      if (!currentGeoPaymentMethodId.value) {
        return;
      }

      getGeoPaymentMethodExceptionLimit(currentGeoPaymentMethodId.value);
      getGeoPaymentMethodGeneralLimit(currentGeoPaymentMethodId.value);
    });

    const addExceptionLimitItem = (currency: string): void => {
      exceptionLimitList.value.push({ ...DEFAULT_EXCEPTION_LIMIT, currency });
    };

    const isAddLimitExceptionButtonVisible = computed<boolean>(() =>
      psManagementPermissions.value[PS_MANAGEMENT_PERMISSIONS.CREATE_METHOD_EXTENDED_LIMIT],
    );

    const updateExceptionLimitItem = (updatedLimitItem: PaymentMethodExceptionLimit): void => {
      const index = exceptionLimitList.value.findIndex(
        ({ id }: PaymentMethodExceptionLimit) => id === updatedLimitItem.id,
      );

      if (index !== -1) {
        exceptionLimitList.value[index] = updatedLimitItem;
      }
    };

    const isAddExceptionLimitItemEnable = (currency: string): boolean => {
      const limitGroup = extendedPaymentMethodExceptionLimitList.value.find(group => group.currency === currency);
      const allLimitsHaveId = limitGroup ? limitGroup.limitList.every(limit => limit.id) : true;

      return Boolean(limitGroup) && allLimitsHaveId;
    };

    return {
      isExceptionLimitSettingsSidebarVisible,
      isExceptionLimitListLoading,
      extendedPaymentMethodExceptionLimitList,
      addExceptionLimitItem,
      closeExceptionLimitSettings,
      currentGeoPaymentMethod,
      isAddLimitExceptionButtonVisible,
      updateExceptionLimitItem,
      isAddExceptionLimitItemEnable,
    };
  },
});
